import { Component, Input } from '@angular/core';

import { DecisionSource } from '@bpos/v1/over-ask';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { IBetslipOverAskPickListProps, IBetslipOverAskSummaryComponentProps } from '../models/over-ask.model';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskReviewBaseComponent {
    @Input() pickListProps: IBetslipOverAskPickListProps;
    @Input() summaryProps: IBetslipOverAskSummaryComponentProps;
    @Input() remainingSeconds: number;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() decisionSource?: DecisionSource;

    overAskFlowState = OverAskFlowState.Review;
}
